export enum EventType {
  NewEvent = 45,
}